module.exports = __webpack_public_path__ + "img/p15.c8f3103e.svg";